module.exports = __webpack_public_path__ + "img/woman_2_icon.06100f8f.png";